import React from 'react';
import styles from './ThinProgressBar.module.scss';

function ThinProgressBar({ percentage, barClassName = '', style = {} }) {
  const pct = Number(percentage);
  if (isNaN(pct)) return null;
  return (
    <div className={styles['progress-container']} style={style}>
      <div className={`progress ${styles['progress']}`}>
        <div className={`progress-bar ${barClassName}`} style={{ width: `${pct > 100 ? 100 : pct}%`}} /> 
      </div>
      <div className={`description ${styles['progress-text']}`}>
        {pct}%
      </div>
    </div>
  )
}

export default ThinProgressBar;